<button type="button" class="pm-gomb" [class.vilagos]="!sotetFejlec" (click)="nyit($event)" *ngIf="k"
        title="Profil · intézmény- és modulváltás · kijelentkezés">
  <img class="pm-avatar" [src]="k.avatarUrl()" alt="" (error)="k.avatarHiba($event)">
  <span class="pm-gomb-nev">{{ k.nev() }}</span>
  <ion-icon name="chevron-down"></ion-icon>
</button>

<ion-popover class="profil-popover" [isOpen]="nyitva" [event]="esemeny" (didDismiss)="nyitva = false"
             [showBackdrop]="true" alignment="end" side="bottom">
  <ng-template>
    <div class="pm" *ngIf="k">
      <!-- a két kép: a felhasználó és az intézmény -->
      <div class="pm-kepek">
        <img class="pm-kep kor" [src]="k.avatarUrl()" alt="" (error)="k.avatarHiba($event)">
        <img class="pm-kep logo" [src]="k.logoUrl()" alt="" (error)="k.logoHiba($event)">
      </div>
      <div class="pm-nev">{{ k.nev() }}</div>
      <div class="pm-hol">{{ k.intezmenyNev() }}</div>

      <div class="pm-cim">Intézmény</div>
      <input *ngIf="osszesIntezmeny > 6" class="pm-szuro" type="search" [(ngModel)]="intezmenySzuro" placeholder="Intézmény keresése…">
      <div class="pm-lista">
        <button type="button" *ngFor="let i of intezmenyek" [class.aktiv]="i.intezmenyId === k.intezmenyId()" (click)="intezmenyValt(i)">
          <ion-icon [name]="i.intezmenyId === k.intezmenyId() ? 'checkmark-circle' : 'business-outline'"></ion-icon>
          <span>{{ i.intezmenyName }}</span>
        </button>
      </div>
      <!--  Más rendszerek intézményei (tobbintezmeny.js) – választáskor a másik rendszer nyílik meg. -->
      <app-tobb-intezmeny [kezel]="true"></app-tobb-intezmeny>

      <ng-container *ngIf="!k.fixedMode()">
        <div class="pm-cim">Modul</div>
        <div class="pm-lista">
          <button type="button" *ngFor="let m of k.modok()" [class.aktiv]="m.name === k.aktualisMod()" (click)="modValt(m)">
            <img class="pm-mod-ikon" [src]="modIkon(m.name)" alt="">
            <span>{{ m.cim }}</span>
            <ion-icon *ngIf="m.name === k.aktualisMod()" name="checkmark" class="pm-pipa"></ion-icon>
          </button>
        </div>
      </ng-container>

      <button type="button" class="pm-admin" *ngIf="adminLathato" (click)="admin()">
        <ion-icon name="settings-outline"></ion-icon><span>Adminisztráció</span><ion-icon name="chevron-forward" class="pm-nyil"></ion-icon>
      </button>
      <button type="button" class="pm-admin" *ngIf="fejleszto" (click)="jogszabalyfigyelo()">
        <ion-icon name="jogszabalyfigyelo"></ion-icon><span>Jogszabályfigyelő</span><ion-icon name="chevron-forward" class="pm-nyil"></ion-icon>
      </button>

      <button type="button" class="pm-admin" (click)="profil()">
        <ion-icon name="person-circle-outline"></ion-icon><span>Profil</span><ion-icon name="chevron-forward" class="pm-nyil"></ion-icon>
      </button>
      <button type="button" class="pm-admin" (click)="beallitasok()">
        <ion-icon name="options-outline"></ion-icon><span>Beállítások</span><ion-icon name="chevron-forward" class="pm-nyil"></ion-icon>
      </button>

      <button type="button" class="pm-kilep" (click)="kilep()"><ion-icon name="log-out-outline"></ion-icon> Kijelentkezés</button>
      <div class="pm-verzio" *ngIf="k.verzio()">{{ k.verzio() }} © Cronomit Group</div>
    </div>
  </ng-template>
</ion-popover>
